import React, {memo} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEText, RNEIconButton} from '../../components';
import {width, height, totalSize} from 'react-native-dimension';

interface EmptyMedicalAttachmentsModalProps {
  onConfirm?: () => void;
}

function EmptyMedicalAttachmentsModal(
  props: EmptyMedicalAttachmentsModalProps,
) {

  return (
    <View style={rneStyles.root}>
      <RNEText
        label="No Medical Attachment"
        variant="header"
        // style={titleFontSize24}
        align="center"
        weight="600"
        color="accent"
        style={{fontSize:totalSize(2.8), fontFamily: 'Quicksand-SemiBold'}}
      />

      <View style={rneStyles.buttonContainer}>
        <RNEIconButton
          icon={<SVGIcon name="check-white" size={48} />}
          color="secondary"
          size={80}
          onPress={props.onConfirm}
          raised={Platform.OS !== 'web'}
        />
      </View>
    </View>
  );
}

const titleFontSize24 = {
  fontSize: Platform.OS === 'web' ? 30 : 24,
};

const rneStyles = StyleSheet.create({
  root: {
    padding: totalSize(3),
    margin: totalSize(3),
    height: height(25),
    justifyContent: 'center',
    alignSelf: 'center',
  },
  buttonContainer: {
    marginTop: totalSize(3.5),
    justifyContent: 'center',
    alignSelf: 'center',
  },
});

export default memo(EmptyMedicalAttachmentsModal);
